import { MutationFn, UseQueryFn } from 'shared-ui';

import { MailAccountRequest, MailAccountResponse } from './mailAccount.types';

export const fetchMailAccount: UseQueryFn<unknown, MailAccountResponse> = () => {
  return {
    endpoint: '/konto-pocztowe',
  };
};

export const updateMailAccount: MutationFn<MailAccountRequest, MailAccountResponse> = (body) => {
  return {
    endpoint: '/konto-pocztowe',
    method: 'PUT',
    body,
  };
};
